import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUnpin: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="unpin"><path d="M8.38235 15.6176L3.75 20.25M8 8.62903L3.75 10L14 20.25L15.371 16M11.75 7.25L14.5 2.75L21.25 9.5L16.75 12.25M2.75 2.75L21.25 21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUnpin;
